import React, {component, Component} from 'react';
import axios from 'axios';
import {passCsrfToken, toTableData} from '../../helpers';
import {getAllPartners, deleteAdminPartner, confirmPartner, activatePartner, deactivatePartner, restoreAdminPartner, updateAdminPartner} from '../../api/partnerApi';

const ASSIGNMENT_OPTIONS = [
  { value: 'GroupTour', label: 'Group trips' },
  { value: 'SharedRental', label: 'Shared rentals' },
  { value: 'PartnerService', label: 'Private tours' }
];
const assignmentTypesToBadges = (s) => {
  if (!s || !s.trim()) return 'All';
  const arr = s.split(',').map((x) => x.trim()).filter(Boolean);
  const labels = arr.map((v) => (ASSIGNMENT_OPTIONS.find((o) => o.value === v) || {}).label || v);
  return labels.length ? labels.join(', ') : 'All';
};
import {Link} from 'react-router-dom';
import swal from 'sweetalert';
import FilterForm from './FilterForm';
import {Segment, Card, Pagination} from 'semantic-ui-react';
import queryString from 'query-string';
import history from '../../history';
import {CustomMenu} from './Menu';
import moment from 'moment';

class PartnerList extends Component {
	constructor(props) {
		super(props);
		this.state = {
			pagination: {},
			partners: [],
			editingPartner: null,
			editForm: {},
			saving: false
		};
	}

	componentDidMount() {
		passCsrfToken(document, axios);
		this.fetchPartners(queryString.parse(this.props.location.search));
	}

	fetchPartners(params) {
		getAllPartners(params)
			.then((response) => {
				const data = response.data || {};
				const list = Array.isArray(data) ? data : (data.vendors || data.partners || []);
				const meta = data.meta || {};
				const pagination = (meta.pagination || data.meta?.pagination) || {};
				this.setState({
					partners: list,
					pagination
				});
			})
			.catch((error) => {
				console.warn('Vendor list fetch error', error);
			});
	}

	onFilter = (values) => {
		const list = Array.isArray(values)
			? values
			: (values.partners || values.vendors || []);
		this.setState({ partners: list });
	};

	changeCurrentPage = (e, {activePage}) => {
		var searchQuery = `?page=${activePage}`;
		this.setState({currentPage: activePage});
		this.fetchPartners({page: activePage});
		history.push({
			pathname: window.location.pathname,
			search: searchQuery
		});
	};

	onConfirm = (partner) => {
		confirmPartner(partner.idx)
			.then(() => { swal('Done', 'Vendor approved and email sent.', 'success'); this.fetchPartners(queryString.parse(this.props.location.search)); })
			.catch((e) => swal('Error', (e.response?.data?.errors || [])?.join(' ') || 'Failed', 'error'));
	};

	onActivate = (partner) => {
		activatePartner(partner.idx)
			.then(() => { swal('Done', 'Vendor activated.', 'success'); this.fetchPartners(queryString.parse(this.props.location.search)); })
			.catch((e) => swal('Error', (e.response?.data?.errors || [])?.join(' ') || 'Failed', 'error'));
	};

	onDeactivate = (partner) => {
		deactivatePartner(partner.idx)
			.then(() => { swal('Done', 'Vendor deactivated.', 'success'); this.fetchPartners(queryString.parse(this.props.location.search)); })
			.catch((e) => swal('Error', (e.response?.data?.errors || [])?.join(' ') || 'Failed', 'error'));
	};

	onDelete = (partner) => {
		swal({ title: 'Delete this vendor?', text: 'They will be soft-deleted. You can restore them later from Status → Deleted.', icon: 'warning', buttons: true, dangerMode: true })
			.then((ok) => {
				if (ok) {
					deleteAdminPartner(partner.idx)
						.then(() => { swal('Deleted', { icon: 'success' }); this.fetchPartners(queryString.parse(this.props.location.search)); })
						.catch((e) => swal('Error', (e.response?.data?.errors || [])?.join(' ') || 'Delete failed', 'error'));
				}
			});
	};

	onRestore = (partner) => {
		swal({
			title: 'Restore this vendor?',
			text: 'They will be active again and can log in as a vendor.',
			icon: 'info',
			buttons: ['Cancel', 'Restore'],
		}).then((ok) => {
			if (!ok) return;
			restoreAdminPartner(partner.idx || partner.id)
				.then(() => {
					swal('Restored', 'Vendor is active again.', 'success');
					this.fetchPartners(queryString.parse(this.props.location.search));
				})
				.catch((e) => swal('Error', (e.response?.data?.errors || [])?.join(' ') || 'Restore failed', 'error'));
		});
	};

	partnerStatusLabel = (partner) => (partner.is_deleted ? 'deleted' : partner.status);

	renderPartnerActions = (partner) => {
		const deleted = partner.is_deleted === true;
		const status = partner.status;
		return (
			<>
				<Link to={`/admin/partner/${partner.idx || partner.id}`} className='btn btn-sm btn-outline-primary mr-1 mb-1 mb-md-0'>View</Link>
				{!deleted && (
					<button type='button' className='btn btn-sm btn-outline-primary mr-1 mb-1 mb-md-0' onClick={() => this.openEdit(partner)}>Edit</button>
				)}
				{!deleted && status === 'approved' && (
					<button type='button' className='btn btn-sm btn-outline-secondary mr-1 mb-1 mb-md-0' onClick={() => this.onDeactivate(partner)}>Deactivate</button>
				)}
				{!deleted && status === 'inactive' && (
					<button type='button' className='btn btn-sm btn-outline-success mr-1 mb-1 mb-md-0' onClick={() => this.onActivate(partner)}>Activate</button>
				)}
				{!deleted && status === 'processing' && (
					<button type='button' className='btn btn-sm btn-outline-secondary mr-1 mb-1 mb-md-0' onClick={() => this.onConfirm(partner)}>Confirm</button>
				)}
				{deleted && (
					<button type='button' className='btn btn-sm btn-outline-success mr-1 mb-1 mb-md-0' onClick={() => this.onRestore(partner)}>Restore</button>
				)}
				{!deleted && (
					<button type='button' className='btn btn-sm btn-outline-danger mb-1 mb-md-0' onClick={() => this.onDelete(partner)}>Delete</button>
				)}
			</>
		);
	};

	openEdit = (partner) => {
		const at = partner.assignment_types;
		const assignmentTypes = at && at.trim() ? at.split(',').map((s) => s.trim()).filter(Boolean) : ['GroupTour', 'SharedRental', 'PartnerService'];
		this.setState({
			editingPartner: partner,
			editForm: {
				first_name: partner.first_name || '',
				last_name: partner.last_name || '',
				email: partner.email || '',
				contact_number: partner.contact_number || '',
				company_name: partner.company_name || '',
				khalti_identifier: partner.khalti_identifier || '',
				company_type: partner.company_type || 'vendor',
				vendor_type: partner.vendor_type || partner.company_type || 'vendor',
				assignment_types: assignmentTypes,
				company_email: partner.company_email || '',
				company_contact_number: partner.company_contact_number || '',
				company_address: partner.company_address || '',
				website: partner.website || ''
			}
		});
	};

	toggleEditAssignmentType = (value) => {
		this.setState((s) => {
			const arr = (s.editForm.assignment_types || []).includes(value)
				? (s.editForm.assignment_types || []).filter((t) => t !== value)
				: [...(s.editForm.assignment_types || []), value];
			return { editForm: { ...s.editForm, assignment_types: arr } };
		});
	};

	closeEdit = () => {
		this.setState({ editingPartner: null, editForm: {}, saving: false });
	};

	onEditFormChange = (field, value) => {
		this.setState((s) => ({ editForm: { ...s.editForm, [field]: value } }));
	};

	saveEdit = () => {
		const { editingPartner, editForm } = this.state;
		const idOrIdx = editingPartner?.idx || editingPartner?.id;
		const payload = { ...editForm };
		if (Array.isArray(payload.assignment_types)) payload.assignment_types = payload.assignment_types.join(',');
		payload.vendor_type = payload.vendor_type || payload.company_type || 'vendor';
		if (!editingPartner || !idOrIdx) {
			swal('Error', 'Missing vendor identifier.', 'error');
			return;
		}
		this.setState({ saving: true });
		updateAdminPartner(idOrIdx, payload)
			.then(() => {
				swal('Saved', 'Vendor updated.', 'success');
				this.closeEdit();
				this.fetchPartners(queryString.parse(this.props.location.search));
			})
			.catch((e) => {
				const msg = (e.response?.data?.errors || [])?.join(' ') || e.message || 'Update failed';
				const isEmailInUse = msg && msg.toLowerCase().includes('email already in use');
				swal(isEmailInUse ? 'Email already in use' : 'Error', msg, 'error');
				this.setState({ saving: false });
			});
	};

	render() {
		const {partners, pagination} = this.state;
		const filterFields = [
			{
				name: 'created_at_gteq',
				label: 'From Date',
				type: 'date'
			},
			{
				name: 'created_at_lteq',
				label: 'To Date',
				type: 'date'
			},
			{
				name: 'first_name_or_last_name_cont',
				label: 'Name',
				type: 'text'
			},

			{
				name: 'email_cont',
				label: 'email',
				type: 'text'
			},

			{
				name: 'contact_number_cont',
				label: 'Mobile Number',
				type: 'text'
			}
		];

		return (
			<div className='ui container admin-partners-page'>
				{/* <FilterForm submitUrl='partners' fields={filterFields} onSubmit={(values) => this.onFilter(values)} /> */}
				<CustomMenu
					submitUrl='admin/vendors'
					filterFields={filterFields}
					onFilter={(values) => this.onFilter(values)}
						items={[
							{
								label: 'Status',
								type: 'dropdown',
								name: 'status_eq',
								objects: [
									{ label: 'Processing', value: 'processing' },
									{ label: 'Approved', value: 'approved' },
									{ label: 'Inactive', value: 'inactive' },
									{ label: 'Deleted', value: 'deleted' },
									{ label: 'Pending', value: 'pending' },
									{ label: 'Verified', value: 'verified' }
								]
							}
						]}
				/>
				<Segment>
					<Card fluid>
						<Card.Content>
							<h3 className='title'>All Vendors</h3>

							{/* Mobile: card list (no wide table) */}
							<div className='admin-partner-list-mobile d-block d-md-none'>
								{partners.map((partner, index) => {
									const pending = partner.total_pending_count != null ? partner.total_pending_count : (partner.listing_pending ? (partner.listing_pending.group_tours || 0) + (partner.listing_pending.shared_rentals || 0) + (partner.listing_pending.packages || 0) : 0);
									const live = partner.total_live_count != null ? partner.total_live_count : (partner.listing_live ? (partner.listing_live.group_tours || 0) + (partner.listing_live.shared_rentals || 0) + (partner.listing_live.packages || 0) : 0);
									const hasPending = pending > 0;
									return (
										<div key={partner.idx || partner.id} className={`admin-partner-card mb-3 p-3 border rounded ${hasPending ? 'border-warning bg-light' : ''}`}>
											<div className='d-flex justify-content-between align-items-start flex-wrap gap-2'>
												<div className='flex-grow-1 min-w-0'>
													<div className='font-weight-bold text-dark'>
														{partner.first_name} {partner.last_name}
													</div>
													<div className='small text-break'>{partner.email}</div>
													{(partner.company_name || partner.contact_number) && (
														<div className='small text-muted mt-1'>
															{partner.company_name && <span>{partner.company_name}</span>}
															{partner.company_name && partner.contact_number && ' · '}
															{partner.contact_number && <a href={`tel:${partner.contact_number}`}>{partner.contact_number}</a>}
														</div>
													)}
													<div className='d-flex flex-wrap align-items-center mt-2'>
														<span className={`badge mr-1 ${partner.is_deleted ? 'badge-secondary' : 'badge-secondary'}`}>{this.partnerStatusLabel(partner)}</span>
														<span className='small text-muted'>{assignmentTypesToBadges(partner.assignment_types)}</span>
														<span className='small text-muted ml-1'>{moment(partner.created_at).format('D MMM YYYY')}</span>
													</div>
													<Link to={`/admin/partner/${partner.idx || partner.id}`} className={`d-inline-block mt-2 ${hasPending ? 'text-danger font-weight-bold' : ''}`}>
														Pending: {pending} | Live: {live}
														{hasPending && partner.listing_pending && (
															<span className='small d-block text-muted'>G{partner.listing_pending.group_tours || 0} · S{partner.listing_pending.shared_rentals || 0} · P{partner.listing_pending.packages || 0}</span>
														)}
													</Link>
												</div>
												<div className='d-flex flex-wrap'>
													{this.renderPartnerActions(partner)}
												</div>
											</div>
										</div>
									);
								})}
							</div>

							{/* Desktop: table */}
							<div className='table-responsive d-none d-md-block'>
								<table className='table table-striped table-hover table-sm' ref='main'>
									<thead>
										<tr>
											<th>S. No.</th>
											<th>Name</th>
											<th>Email</th>
											<th>Company</th>
											<th>Khalti ID</th>
											<th>Types</th>
											<th>Contact</th>
											<th>Status</th>
											<th>Created</th>
											<th>Listings</th>
											<th>Actions</th>
										</tr>
									</thead>
									<tbody>
										{partners.map((partner, index) => {
											const pending = partner.total_pending_count != null ? partner.total_pending_count : (partner.listing_pending ? (partner.listing_pending.group_tours || 0) + (partner.listing_pending.shared_rentals || 0) + (partner.listing_pending.packages || 0) : 0);
											const live = partner.total_live_count != null ? partner.total_live_count : (partner.listing_live ? (partner.listing_live.group_tours || 0) + (partner.listing_live.shared_rentals || 0) + (partner.listing_live.packages || 0) : 0);
											const hasPending = pending > 0;
											return (
												<tr key={partner.idx || partner.id} className={hasPending ? 'table-warning' : ''}>
													<td>{index + 1}</td>
													<td>
														{partner.first_name}&nbsp;
														{partner.last_name}
													</td>
													<td>{partner.email}</td>
													<td>{partner.company_name || '—'}</td>
													<td>{partner.khalti_identifier || '—'}</td>
													<td><span className="small text-muted">{assignmentTypesToBadges(partner.assignment_types)}</span></td>
													<td>{partner.contact_number || '—'}</td>
													<td>{this.partnerStatusLabel(partner)}</td>
													<td>{moment(partner.created_at).format('D MMM YYYY')}</td>
													<td>
														<Link to={`/admin/partner/${partner.idx || partner.id}`} className={hasPending ? 'text-danger font-weight-bold' : ''} title={hasPending ? 'Pending approval' : 'Listings'}>
															Pending: {pending} | Live: {live}
															{hasPending && partner.listing_pending && (
																<span className="small d-block text-muted">G{partner.listing_pending.group_tours || 0} · S{partner.listing_pending.shared_rentals || 0} · P{partner.listing_pending.packages || 0}</span>
															)}
														</Link>
													</td>
													<td>
														{this.renderPartnerActions(partner)}
													</td>
												</tr>
											);
										})}
									</tbody>
								</table>
							</div>
						</Card.Content>
					</Card>
				</Segment>
				<div className='text-center p-2'>
					<Pagination
						activePage={Number(pagination.current_page) || 1}
						sizePerPage={Number(pagination.per_page) || 10}
						onPageChange={this.changeCurrentPage}
						totalPages={Math.max(1, Number(pagination.total_pages) || 1)}
					/>
				</div>

				{this.state.editingPartner && (
					<div className='modal fade show d-block' style={{ background: 'rgba(0,0,0,0.5)' }} tabIndex={-1}>
						<div className='modal-dialog modal-dialog-centered modal-lg' style={{ maxHeight: '90vh', margin: '1.75rem auto' }}>
							<div className='modal-content' style={{ maxHeight: '90vh', display: 'flex', flexDirection: 'column' }}>
								<div className='modal-header flex-shrink-0'>
									<h5 className='modal-title'>Edit vendor</h5>
									<button type='button' className='close' onClick={this.closeEdit}><span>&times;</span></button>
								</div>
								<div className='modal-body overflow-auto' style={{ flex: '1 1 auto', minHeight: 0 }}>
									<div className='row'>
										<div className='col-md-6'>
											<div className='form-group'>
												<label>First name</label>
												<input type='text' className='form-control' value={this.state.editForm.first_name || ''} onChange={(e) => this.onEditFormChange('first_name', e.target.value)} />
											</div>
											<div className='form-group'>
												<label>Last name</label>
												<input type='text' className='form-control' value={this.state.editForm.last_name || ''} onChange={(e) => this.onEditFormChange('last_name', e.target.value)} />
											</div>
											<div className='form-group'>
												<label>Email</label>
												<p className='form-control-plaintext text-muted mb-0' title='Login email is managed by the user account; not editable here.'>{this.state.editForm.email || '—'}</p>
											</div>
											<div className='form-group'>
												<label>Contact number</label>
												<input type='text' className='form-control' value={this.state.editForm.contact_number || ''} onChange={(e) => this.onEditFormChange('contact_number', e.target.value)} />
											</div>
										</div>
										<div className='col-md-6'>
											<div className='form-group'>
												<label>Company name</label>
												<input type='text' className='form-control' value={this.state.editForm.company_name || ''} onChange={(e) => this.onEditFormChange('company_name', e.target.value)} />
											</div>
											<div className='form-group'>
												<label>Khalti ID</label>
												<input type='text' className='form-control' placeholder='For payouts' value={this.state.editForm.khalti_identifier || ''} onChange={(e) => this.onEditFormChange('khalti_identifier', e.target.value)} />
											</div>
											<div className='form-group'>
												<label>Vendor type</label>
												<select className='form-control' value={this.state.editForm.company_type || 'vendor'} onChange={(e) => this.onEditFormChange('company_type', e.target.value)}>
													<option value='vendor'>Vendor (general)</option>
													<option value='Vehicle rental'>Vehicle rental</option>
													<option value='Tour operator'>Tour operator</option>
												</select>
											</div>
											<div className='form-group'>
												<label>Can be assigned to</label>
												<div className='d-flex flex-wrap'>
													{ASSIGNMENT_OPTIONS.map((opt) => (
														<label key={opt.value} className='mr-3 mb-0'>
															<input type='checkbox' checked={(this.state.editForm.assignment_types || []).includes(opt.value)} onChange={() => this.toggleEditAssignmentType(opt.value)} className='mr-1' />
															{opt.label}
														</label>
													))}
												</div>
											</div>
											<div className='form-group'>
												<label>Company email</label>
												<input type='email' className='form-control' value={this.state.editForm.company_email || ''} onChange={(e) => this.onEditFormChange('company_email', e.target.value)} />
											</div>
											<div className='form-group'>
												<label>Company contact</label>
												<input type='text' className='form-control' value={this.state.editForm.company_contact_number || ''} onChange={(e) => this.onEditFormChange('company_contact_number', e.target.value)} />
											</div>
											<div className='form-group'>
												<label>Company address</label>
												<input type='text' className='form-control' value={this.state.editForm.company_address || ''} onChange={(e) => this.onEditFormChange('company_address', e.target.value)} />
											</div>
											<div className='form-group'>
												<label>Website</label>
												<input type='text' className='form-control' value={this.state.editForm.website || ''} onChange={(e) => this.onEditFormChange('website', e.target.value)} />
											</div>
										</div>
									</div>
								</div>
								<div className='modal-footer flex-shrink-0 border-top bg-light py-3'>
									<button type='button' className='btn btn-secondary' onClick={this.closeEdit}>Cancel</button>
									<button type='button' className='btn btn-primary ml-2' onClick={this.saveEdit} disabled={this.state.saving}>{this.state.saving ? 'Saving…' : 'Save'}</button>
								</div>
							</div>
						</div>
					</div>
				)}
			</div>
		);
	}
}
export default PartnerList;
